// src/contexts/geral/YesNoContext.js
import React, { createContext, useContext, useState, useCallback, useRef } from 'react';
import ModalMsgYesNo from '../../components/modal/ModalMsgYesNo';

const YesNoContext = createContext();

export const useYesNo = () => useContext(YesNoContext);

export const YesNoProvider = ({ children }) => {
    const [isOpen, setIsOpen] = useState(false);
    const [message, setMessage] = useState('');
    const [focusOn, setFocusOn] = useState('yes');
    const resolveFnRef = useRef(null);

    const showYesNo = useCallback((msg, focusOn = 'yes') => {
        return new Promise((resolve) => {
            setMessage(msg);
            setFocusOn(focusOn === 'no' ? 'no' : 'yes');
            resolveFnRef.current = resolve; // Armazena a função resolve
            setIsOpen(true);
        });
    }, []);

    const handleResolve = (value) => {
        if (resolveFnRef.current) {
            resolveFnRef.current(value); // Resolve a Promise com o valor (true ou false)
            resolveFnRef.current = null; // Limpa a função resolve
        }
        setIsOpen(false); // Fecha o modal
    };

    return (
        <YesNoContext.Provider value={{ showYesNo }}>
            {children}
            <ModalMsgYesNo
                isOpen={isOpen}
                message={message}
                focusOn={focusOn}
                resolve={handleResolve}
            />
        </YesNoContext.Provider>
    );
};
